export default {
  methods: {
    // Rounds each share to one decimal place (largest remainder method) so the rows add up to exactly 100%
    toPercentLabels(counts) {
      const total = counts.reduce((sum, count) => sum + count, 0)
      if (total < 1) return counts.map(() => '0.0%')

      const tenths = counts.map(count => (count / total) * 1000)
      const rounded = tenths.map(Math.floor)
      let remaining = 1000 - rounded.reduce((sum, value) => sum + value, 0)

      tenths
        .map((value, index) => ({ index, remainder: value - rounded[index] }))
        .sort((a, b) => b.remainder - a.remainder)
        .forEach(({ index }) => {
          if (remaining > 0) {
            rounded[index] += 1
            remaining -= 1
          }
        })

      return rounded.map(value => `${(value / 10).toFixed(1)}%`)
    },
  },
}
